import get from "../utils/get";
// Looks the token up in the tokens object
export const getJsToken = Object.assign((path, fallback, tokens) => {
    var _a;
    const result = get(tokens, path.join("."));
    // Makes sure consumers don't have to pass in `default` for default states
    return (_a = (typeof result === "object" ? result.default : result)) !== null && _a !== void 0 ? _a : fallback;
}, { kind: "js" });
// Builds a reference to the token's CSS variable, no tokens needed
const SEGMENT = /^[\w-]+$/;
export const getCssToken = Object.assign((path, fallback) => {
    // A token path is always category + key, starting with a letter, and every
    // segment must be valid in a variable name (rules out "10px", "100%", "#FFF")
    const isTokenPath = path.length > 1 &&
        /^[a-zA-Z]/.test(path[0]) &&
        path.every((segment) => SEGMENT.test(segment));
    if (!isTokenPath)
        return fallback;
    const name = `--${path.join("-")}`.replace(/_/g, "-");
    const defaultVar = fallback === undefined
        ? `var(${name}-default)`
        : `var(${name}-default, ${fallback})`;
    return `var(${name}, ${defaultVar})`;
}, { kind: "css" });
//# sourceMappingURL=tokenGetters.js.map